export default {
  "pl": {
    "survey": {
      "actions": {
        "add": "Dodaj nową",
        "close": "Zamknij",
        "create": "Utwórz",
        "delete": "Usuń",
        "deleteCount": "Zamierzasz usunąć {count} ankietę. Czy na pewno chcesz to zrobić? | Zamierzasz usunąć następującą liczbę ankiet: {count}. Czy na pewno chcesz to zrobić?",
        "deleteMultiple": "Usuń…",
        "delete_cancel": "Anuluj",
        "delete_surveys": "Usuń ankietę | Usuń ankiety",
        "newSurvey": "Nowa ankieta",
        "publish": "Opublikuj",
        "publishCustomer": "Opublikuj dla klientów",
        "save": "Zapisz",
        "selectAll": "Wybierz wszystkie ankiety ({total})",
        "submit": "Prześlij",
        "surveys_collapse": "Zamknij wszystkie ankiety",
        "surveys_expand": "Otwórz wszystkie ankiety",
        "unSelectAll": "Wyczyść wybór.",
        "unpublish": "Cofnij publikację"
      },
      "attributes": {
        "description": "Tytuł do użytku wewnętrznego",
        "title": "Twoje pytanie"
      },
      "labels": {
        "NPSOverview": "Przegląd NPS",
        "NPSQuestion": "Jakie jest prawdopodobieństwo, że polecisz firmę {name} znajomemu lub współpracownikowi?",
        "allUnitsAssigned": "Wszystkie przypisane jednostki",
        "answer_later": "Odpowiedz później",
        "answeredAt": "Odpowiedział w",
        "average_score": "Średni wynik",
        "clientTeam": "Zespół – {name}",
        "comments": "Komentarze lub sugestie (opcjonalnie)",
        "completedTime": "Data",
        "customer": "Klient",
        "customer_status": "Status",
        "detractors": "Przeciwnicy",
        "extremelyLikely": "To bardzo prawdopodobne",
        "list": "Lista",
        "neutrals": "Neutralni",
        "noSurveyFeedback": "Brak komentarzy lub sugestii",
        "noUnitsClick": "Brak jednostek – kliknij tutaj, aby dodać",
        "no_opinion": "Brak opinii",
        "notAtAllLikely": "To zupełnie nieprawdopodobne",
        "nps": "NPS",
        "pendingSurveys": " 1 ankieta do wypełnienia | Liczba ankiet do wypełnienia: {count}",
        "promoters": "Zwolennicy",
        "publishNow?": "Opublikować teraz?",
        "publishedCount": "Opublikuj tę ankietę dla klienta | Opublikuj dla klientów następującą liczbę ankiet: {count}",
        "question": "Pytanie",
        "respondents": "Brak odpowiadających | 1 odpowiadający | Liczba odpowiadających: {count}",
        "response": "Odpowiedź",
        "responses": "Odpowiedzi",
        "saveExplainer": "Czy chcesz udostępnić tę ankietę klientom? A może wolisz zapisać ją i opublikować później?",
        "scoreBreakdown": "Analiza wyniku",
        "selectOneUnit": "Wybierz co najmniej 1 ankietę",
        "selectUnits": "Wybierz jednostki",
        "selected": "Wybrano {selected} ankietę. | Wybrano następującą liczbę ankiet: {selected}.",
        "showSurveysFor": "Pokaż ankiety dla jednostki:",
        "step3Subtitle": "Wybierz swój projekt, aby uwzględnić wszystkie jednostki naraz.",
        "step3Title": "Dla których jednostek chcesz utworzyć ankietę?",
        "survey": "Ankieta",
        "surveyAlreadyAnswered": "Udzielono już odpowiedzi w tej ankiecie. Dziękujemy za twoją opinię.",
        "surveyAnswer": "Opinia",
        "surveyNotCompleted": "Nie dokończono wypełniania ankiety.",
        "surveys": "Ankiety",
        "surveysCount": "{count} ankieta | Liczba ankiet: {count}",
        "thankYou": "Dziękujemy za twoją opinię!",
        "title": "Pytanie",
        "totalSelected": "Wybrano wszystkie ankiety ({total}).",
        "unit": "Jednostka",
        "unitSelected": "Nie wybrano jednostki | Wybrano 1 jednostkę | Wybrano następującą liczbę jednostek: {count}",
        "units": "Jednostki",
        "unitsWithoutSurvey": "{count} jednostka bez ankiety | Liczba jednostek bez ankiety: {count}",
        "unpublishedCount": "Cofnij publikację tej ankiety | Cofnij publikację następującej liczby ankiet: {count}",
        "visibility": "Widoczność",
        "yourQuestion": "Twoje pytanie"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Poproś klientów o opinie",
            "title": "Utwórz swoją pierwszą ankietę"
          },
          "none": {
            "subtitle": "Poproś klientów o opinie",
            "title": "Nie znaleziono ankiet"
          }
        }
      },
      "toasts": {
        "bulk_create": "Ankieta została utworzona | Ankiety zostały utworzone",
        "bulk_delete": "Ankieta została usunięta | Ankiety zostały usunięte",
        "bulk_update": "Ankieta została zaktualizowana | Ankiety zostały zaktualizowane",
        "update": "Ankieta została zaktualizowana"
      },
      "validation": {
        "needName": "Podaj pytanie",
        "selectUnit": "Wybierz przynajmniej 1 jednostkę"
      }
    }
  }
}
